/** Programs, risk monitor, breaches and approvals (admin, P5). */
export default {
  tabs: { programs: "Programs", risk: "Risk monitor", breaches: "Breaches", approvals: "Approvals", fairplay: "Fair play", news: "News" },
  markets: { fx: "FX / CFD", futures: "Futures", crypto: "Crypto" },
  programs: {
    name: "Program",
    market: "Market",
    published: "Published",
    draft: "Draft",
    accounts: "Accounts",
    none: "—",
    back: "All programs",
    versions: "Versions",
    version: "v{n}",
    status: { draft: "draft", published: "published", retired: "retired" },
    editDraft: "Edit as a new draft",
    editor: "Draft of the next version",
    frozenNote: "A published version never changes. Accounts already bought stay on their version.",
    accountSize: "Account size, $",
    price: "Price, $",
    listPrice: "List price, $",
    launchPricing: "Launch pricing",
    dayBoundary: "Trading day ends at",
    timezone: "Time zone",
    cmeSession: "CME session (17:00 Chicago)",
    leverage: "Leverage",
    phase: "Phase {n}: {name}",
    funded: "Funded",
    target: "Profit target, %",
    dll: "Daily loss, %",
    dllBase: "Daily loss base",
    bases: { initial: "Initial balance", day_start_balance: "Day-start balance", day_start_equity: "Day-start equity", max_day_start_balance_equity: "Max of day-start balance and equity" },
    dllAction: "On daily loss",
    actions: { fail: "Fail the account", pause_until_next_day: "Pause until the next day" },
    ml: "Max loss, %",
    mlMode: "Max loss type",
    modes: { static: "Static", trailing_eod: "Trailing, end of day", trailing_intraday_balance: "Trailing, intraday balance", trailing_equity_hwm: "Trailing, equity high-water mark" },
    lock: "Trailing stops at the start balance",
    minDays: "Minimum trading days",
    microHold: "Micro-scalp: trades held under, s",
    microShare: "Micro-scalp profit, max % of profit",
    streakDays: "Payout: profitable days in a row",
    streakPct: "Each of those days at least, % of the account",
    streakConsecutive: "Those days must follow each other",
    consistency: "Best day ≤ % of profit",
    split: "Profit split, %",
    json: "All rules (JSON)",
    jsonInvalid: "The JSON is not valid: {error}",
    saveDraft: "Save draft",
    saved: "Draft saved",
    diff: "Changes against the published version",
    noChanges: "No changes",
    publish: "Publish",
    publishConfirm: "Publish version {n}? It becomes immutable and goes on sale; the previous version is retired for new sales.",
    publishedOk: "Version {n} published",
    create: "New program",
    slug: "Slug (a-z, 0-9, -)",
    family: "Family",
    billing: "Billing",
    billings: { one_time: "One-time", monthly: "Monthly" },
    preview: "Summary",
    summary: {
      target: "Target {v}",
      dll: "daily loss {v} ({base}, {action})",
      ml: "max loss {v} ({mode})",
      days: "{n} trading days",
      daysBar: "{n} trading days at ≥ {v} % profit",
      tradeLoss: "loss of one trade ≤ {v}, open or closed",
      window: "{h} h from the first trade",
      duration: "{n} days to pass",
      maxDays: "at most {n} trading days",
      inactivity: "{n} days without a trade end the account",
      contracts: "up to {n} contracts per instrument",
      flat: "positions close at {time}",
      weekend: "FX / CFD positions close Fri 16:55 New York",
      news: "no new trades ±{n} min of high-impact news",
      consistency: "best day ≤ {v} %",
      microScalp: "trades under {sec} s ≤ {v} % of profit",
      streak: "payout after {n} profitable days in a row, each ≥ {v}",
      payouts: "Payouts",
      split: "split {v} %",
    },
  },
  monitor: {
    title: "Accounts by proximity to a breach",
    account: "Account",
    trader: "Trader",
    phase: "Phase",
    status: "Status",
    equity: "Equity",
    dllLeft: "Daily loss left",
    mlLeft: "Max loss left",
    used: "Limit used",
    empty: "No challenge or funded accounts yet",
  },
  states: {
    created: "created",
    active: "active",
    paused: "paused for the day",
    phase_passed: "phase passed",
    pending_review: "in review",
    kyc_required: "KYC required",
    funded_pending: "funding",
    funded: "funded",
    breached: "breached",
    failed: "failed",
    expired: "expired",
    suspended: "suspended",
    closed: "closed",
    refunded: "refunded",
  },
  rules: { max_loss: "Max loss", daily_loss: "Daily loss", consistency: "Consistency", max_duration: "Max duration", inactivity: "Inactivity", max_trade_loss: "Max loss per trade", max_trading_days: "Trading days used up" },
  card: {
    back: "Back",
    risk: "Risk now",
    balance: "Balance",
    equity: "Equity",
    dll: "Daily loss limit",
    ml: "Max-loss floor",
    target: "Target",
    days: "Trading days",
    breaches: "Breaches",
    noBreaches: "No breaches",
    threshold: "Threshold",
    observed: "Observed",
    source: "Price source",
    positions: "Positions at the decision",
    timeline: "State history",
    replay: "Replay",
    replayRun: "Replay with the account's rules",
    whatIf: "What-if",
    whatIfDll: "Daily loss, %",
    whatIfMl: "Max loss, %",
    whatIfRun: "Replay with these rules",
    outcome: { breached: "Breach", passed: "Pass", open: "No decision" },
    observations: "{n} recorded observations",
    manual: "Manual action",
    event: "Action",
    events: { suspend: "Suspend", unsuspend: "Unsuspend", reinstate_from_breach: "Reinstate after a breach (second approval)", force_pass: "Pass the phase (second approval)", close: "Close", penalty_reset: "Reset with the 50 % payout penalty" },
    penaltyDone: "Reset: new account {id}, payouts at 50 %",
    submit: "Submit",
    pending: "Sent for a second approval",
    reinstateHint: "A reinstate does not correct the balance. After a max or daily loss breach the account breaches again on the next check unless you add a correction here (a platform error only).",
    adjustment: "Balance correction, USD (optional, + or −)",
    adjustmentReason: "Reason for the correction",
  },
  approvals: {
    title: "Four-eyes requests",
    account: "Account",
    action: "Action",
    reason: "Reason",
    requestedBy: "Requested by",
    status: "Status",
    approve: "Approve",
    reject: "Reject",
    statuses: { pending: "pending", approved: "approved", rejected: "rejected", executed: "executed" },
    ownRequest: "Your own request — another person approves it",
    adjustment: "correction {v}",
    empty: "No requests",
  },
  news: {
    title: "News calendar",
    lead: "High-impact events open a news window on programs that have one (FX / CFD funded: ±2 min): no new or bigger position on instruments of the tagged currencies or markets; closing is always allowed. The engine reads the calendar every 30 s.",
    at: "Time (your time zone)",
    name: "Event",
    tags: "Currencies / markets",
    tagsHint: "comma-separated: USD, EUR, XAU",
    impact: "Impact",
    add: "Add event",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    remove: "Delete",
    empty: "No events in the next 30 days",
    impacts: { high: "high", medium: "medium", low: "low" },
  },
  fairplay: {
    title: "Opposite positions across linked accounts",
    lead: "Long on one account and short on another in the same instrument at the same time, between accounts of one person, of people with the same document or seen from the same network. Hedging between accounts is forbidden: refuse the payout as a rule violation.",
    days: "Period",
    instrument: "Instrument",
    long: "Long",
    short: "Short",
    links: "Link",
    gap: "Opened apart",
    overlap: "Overlap",
    open: "open",
    empty: "No opposite positions across linked accounts in this period",
    link: { same_person: "same person", same_document: "same document", shared_ip: "same network" },
  },
} as const;
